import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AdvisorFeeCreationRequest, AdvisorFeeData, AdvisorFeeEditRequest, AdvisorFeeSearchFilter } from "../../models/advisor-fee.model";

export const advisorFeeCreationRequest = createAction(
        '[AdvisorFee] AdvisorFee creation request', props<{ advisorFeeCreationRequest: AdvisorFeeCreationRequest }>());

export const advisorFeeCreationSuccess = createAction(
        '[AdvisorFee] AdvisorFee creation success', props<{ createdAdvisorFee : AdvisorFeeData }>());

export const advisorFeeCreationFail = createAction(
        '[AdvisorFee] AdvisorFee creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const advisorFeeEdit = createAction(
        '[AdvisorFee] AdvisorFee edit', props<{ advisorFeeToEdit: AdvisorFeeData }>());

export const advisorFeeEditSave = createAction(
        '[AdvisorFee] AdvisorFee edit save', props<{ advisorFeeToEdit: AdvisorFeeEditRequest }>());

export const advisorFeeEditSaveSuccess = createAction(
        '[AdvisorFee] AdvisorFee edit save success', props<{ editedAdvisorFee: AdvisorFeeData }>());

export const advisorFeeEditSaveFail = createAction(
        '[AdvisorFee] AdvisorFee edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const advisorFeeView = createAction(
        '[AdvisorFee] AdvisorFee view', props<{ advisorFeeToView: AdvisorFeeData }>());

export const advisorFeeSearchRequest = createAction(
        '[AdvisorFee] AdvisorFee search request', props<{ searchFilter: AdvisorFeeSearchFilter }>());

export const advisorFeeSearchAllRequest = createAction(
        '[AdvisorFee] AdvisorFee search all request');

export const advisorFeeSearchSuccess = createAction(
        '[AdvisorFee] AdvisorFee search success', props<{ searchResult: AdvisorFeeData[] }>());

export const advisorFeeSearchDataReset = createAction(
        '[AdvisorFee] AdvisorFee search data reset');

export const advisorFeeSearchFail = createAction(
        '[AdvisorFee] AdvisorFee search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const advisorFeeDeleteRequest = createAction(
        '[AdvisorFee] AdvisorFee delete request', props<{ advisorFeeId: number }>());

export const advisorFeeDeleteSuccess = createAction(
        '[AdvisorFee] AdvisorFee delete success', props<{ advisorFeeId: number }>());

export const advisorFeeDeleteFail = createAction(
        '[AdvisorFee] AdvisorFee delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());